export default "__VITE_ASSET__CnaEfP2k__"